'use client';

import type { FC, ReactNode } from 'react';
import { DesktopHeader } from './DesktopHeader';
import { DesktopNav } from './DesktopNav';
import { DesktopDropsFeed } from './DesktopDropsFeed';
import { DesktopFrame } from './DesktopFrame';

interface DesktopLayoutProps {
  children: ReactNode;
  minimal?: boolean;
}

export const DesktopLayout: FC<DesktopLayoutProps> = ({ children, minimal = false }) => (
  <DesktopFrame
    chrome={
      !minimal && (
        <>
          <DesktopDropsFeed />
          <DesktopHeader />
          <DesktopNav />
        </>
      )
    }
  >
    {children}
  </DesktopFrame>
);
